import type { CSSAttribute } from 'goober';
import { createElement } from 'react';
import { setup } from 'goober';

import { useTheme } from '~/hooks/use-theme';

import './index.scss';

setup(createElement, undefined, useTheme);

export type CSS = CSSAttribute;
